import { DestroyRef, Directive, ElementRef, inject } from '@angular/core';

/**
 * Publishes the rendered height of the sticky column header as
 * `--checklist-header-height` on its parent, so section banners can stick
 * right below it even when header labels wrap.
 */
@Directive({
  selector: '[ngBeeChecklistStickyHeader]',
})
export class ChecklistStickyHeaderDirective {
  constructor() {
    const header: HTMLElement = inject(ElementRef).nativeElement;
    if (typeof ResizeObserver === 'undefined') {
      return;
    }
    const observer = new ResizeObserver(() =>
      header.parentElement?.style.setProperty(
        '--checklist-header-height',
        `${header.offsetHeight}px`,
      ),
    );
    observer.observe(header);
    inject(DestroyRef).onDestroy(() => observer.disconnect());
  }
}
